/** @jsx jsx */
import { jsx } from '@emotion/core'
import React from 'react'
import { observer } from 'mobx-react'
import { IframeWrap } from '@styles/base.style'
import Iframe from 'react-iframe'

/**
 * 스포츠정보 출처 URL 팝업 (#0011006)
 * - `이슈 키워드`의 NewsPopup 을 복제한 것이다. 원본을 공유하지 않는 이유는
 *   출처 URL 쪽 수정이 인기 검색어로 회귀하지 않게 하기 위함이다 (Design P-2)
 * - QA 에서 두 컴포넌트가 끝까지 동일하면 그때 병합을 검토한다
 */
export interface SourceUrlPopupProps {
  link?: string
}

const SourceUrlPopup: React.FC<SourceUrlPopupProps> = (props => {
  const { link } = props

  return (
    <IframeWrap className="modal">
      <Iframe
        url={link}
        scrolling="yes"
        width="100%"
        frameBorder={0}
      />
    </IframeWrap>
  )
})

export default observer(SourceUrlPopup)
